<script>
export default {
  props: {
    size: {
      type: String,
      default: '18',
    },
  },
}
</script>
<template>
  <svg
    style="fill: currentColor"
    viewBox="0,0,24,24"
    :width="size"
    :height="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.41 6.561a.6.6 0 01.029.848l-9.26 9.922a.7.7 0 01-1.024 0l-2.594-2.779a.6.6 0 11.878-.819l2.228 2.388 8.894-9.53a.6.6 0 01.848-.03z"
    />
  </svg>
</template>
